/* eslint-disable import/no-default-export */
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { MemberModel } from 'types';
import AnonymousHeader from './anonymous-header';
import { AuthenticatedHeader } from './authenticated-header';
import StaticHeader from './static-header';

interface Props {
  me: MemberModel | undefined;
  isLoggedIn: boolean;
  alwaysOpenBoardsMenu: boolean;
  isStatic?: boolean;
  staticHeaderColor?: string;
  currentRoute: string | null;
}

class Header extends React.Component<Props> {
  render() {
    const {
      me,
      isLoggedIn,
      alwaysOpenBoardsMenu,
      isStatic,
      staticHeaderColor,
      currentRoute,
    }: Props = this.props;

    if (isStatic) {
      return <StaticHeader isLoggedIn={isLoggedIn} color={staticHeaderColor} />;
    }

    if (isLoggedIn) {
      return (
        <AuthenticatedHeader
          member={me}
          alwaysOpenBoardsMenu={alwaysOpenBoardsMenu}
          currentRoute={currentRoute}
        />
      );
    } else {
      return <AnonymousHeader />;
    }
  }
}

export default Header;



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/header.tsx